import React from "react";
import { Link } from "react-router-dom";
import NoAuthFooter from "../../components/NoAuthFooter";

export default function CancellationAndRefund() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800  antialiased flex flex-col">
      <main className="grow max-w-4xl w-full mx-auto px-4 sm:px-6 py-10">
        <div className="bg-white rounded shadow-sm border border-gray-200 p-8 sm:p-12 prose prose-sm sm:prose-base max-w-none">
          <h1 className="text-2xl font-bold text-center mb-8 uppercase">
            İPTAL VE İADE KOŞULLARI SÖZLEŞMESİ
          </h1>

          <h2 className="text-lg font-semibold mt-6 mb-2">
            1. SATICI (SAĞLAYICI)
          </h2>
          <div className="mb-4 pl-4 border-l-2 border-gray-300">
            <ul className="list-none pl-0 mb-0">
              <li><strong>Ünvan:</strong> Bucod Yazılım - Burkay Yarışanözer</li>
              <li><strong>E-posta:</strong> <a href="mailto:destek@bucod.com" className="text-blue-600 underline">destek@bucod.com</a></li>
              <li><strong>Adres:</strong> Sanayi, Çelikyay Sokak No: 15/3, İzmit/Kocaeli</li>
            </ul>
          </div>

          <h2 className="text-lg font-semibold mt-6 mb-2">
            2. KONU
          </h2>
          <p className="mb-4 text-justify">
            İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait internet
            sitesinden elektronik ortamda siparişini yaptığı, nitelikleri ve
            satış fiyatı belirtilen yazılım hizmetinin satışı ve teslimi ile
            ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun
            ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince
            tarafların hak ve yükümlülüklerinin saptanmasıdır.
          </p>

          <h2 className="text-lg font-semibold mt-6 mb-2">
            3. SÖZLEŞME KONUSU ÜRÜN VE TESLİMAT
          </h2>
          <p className="mb-2 text-justify">
            <strong>3.1. Dijital Teslimat:</strong> Sözleşme konusu
            sanal/yazılımsal ürün, elektronik ortamda SATICI internet
            sitesinde ALICI adına açılmış olan üyelik altında
            kullanılabilir olarak teslim edilir. İşbu ürün tipi için
            fiziksel bir gönderim sağlanmaz.
          </p>
          <p className="mb-2 text-justify">
            <strong>3.2.</strong> SATICI, sözleşme konusu sanal ürünün
            siparişte belirtilen niteliklere uygun ve eksiksiz olarak
            teslim edilmesinden sorumludur.
          </p>
          <p className="mb-4 text-justify">
            <strong>3.3.</strong> Siparişin gerçekleşmesi ve bedelinin
            ödenmesini müteakip ürün ALICI’ya teslim edilmiş sayılır.
            Herhangi bir nedenle ürün bedeli ödenmez veya banka
            kayıtlarında iptal edilir ise, SATICI ürünün teslimi
            yükümlülüğünden kurtulmuş kabul edilir.
          </p>

          <h2 className="text-lg font-semibold mt-6 mb-2">
            4. GENEL HÜKÜMLER
          </h2>
          <p className="mb-2 text-justify">
            <strong>4.1.</strong> ALICI, SATICI internet sitesinde
            sözleşme konusu ürünün temel nitelikleri, satış fiyatı ve
            ödeme şekli ile teslimata ilişkin ön bilgileri okuyup bilgi
            sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini
            beyan eder.
          </p>
          <p className="mb-2 text-justify">
            <strong>4.2. Güvenlik ve İptal:</strong> Ürünün tesliminden
            sonra kredi kartının yetkisiz kişilerce haksız veya hukuka
            aykırı olarak kullanılması nedeniyle ilgili bankanın ürün
            bedelini SATICI'ya ödememesi halinde, SATICI lisans
            anahtarının veya kullanıcı girişinin aktivasyonunu derhal
            iptal etme hakkına sahiptir.
          </p>
          <p className="mb-4 text-justify">
            <strong>4.3. Yaş Sınırı ve Hatalar:</strong> 18 yaşından küçük
            kişiler SATICI'dan alışveriş yapamaz. Dizgi ve sistem
            hatalarından meydana gelen fiyat yanlışlıklarından SATICI
            sorumlu değildir.
          </p>

          <h2 className="text-lg font-semibold mt-6 mb-2">
            5. CAYMA HAKKI VE İADE POLİTİKASI
          </h2>
          <p className="mb-2 text-justify">
            <strong>5.1. Cayma Hakkı İstisnası:</strong> Niteliği
            itibarıyla iade edilemeyecek ürünler, kopyalanabilir yazılım
            ve programlar ve elektronik ortamda anında ifa edilen
            hizmetler için Mesafeli Sözleşmeler Yönetmeliği uyarınca cayma
            hakkı kullanılamaz.
          </p>
          <p className="mb-2 text-justify">
            <strong>5.2. Ön Deneme Beyanı:</strong> ALICI, sistemi satın
            almadan önce "14 Gün" ücretsiz deneme süresince test ettiğini
            ve sistemin ihtiyaçlarına uygunluğunu teyit ettiğini kabul
            eder. Ücretli plana geçiş yapıldıktan sonra iade yapılmaz.
          </p>
          <p className="mb-4 text-justify">
            <strong>5.3.</strong> Sistemsel hatalar sonucu oluşan mükerrer
            çekimler dışında, kullanılmış dönemlerin bedeli iade edilmez.
          </p>

          <h2 className="text-lg font-semibold mt-6 mb-2">
            6. YETKİLİ MAHKEME
          </h2>
          <p className="mb-4 text-justify">
            İşbu sözleşmenin uygulanmasında, Gümrük ve Ticaret Bakanlığınca
            ilan edilen değere kadar <strong>Tüketici Hakem Heyetleri</strong> ile SATICI'nın
            yerleşim yerindeki <strong>Tüketici Mahkemeleri</strong> yetkilidir.
          </p>
        </div>
      </main>
      <NoAuthFooter />
    </div>
  );
}
